import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import Service from '../../../util/Service';

import DateFormat from '../../util/DateFormat';
import { Button, IconButton } from '@mui/material';
import '../../../App.css';

export default function ModeloTable() {
    const [lista, setLista] = React.useState();
    const navigate = useNavigate();

    React.useEffect(() => {
        Service.GET("/api/security/template/findAll").then(r => {
            console.log(r);
            setLista(r);
        })
    }, [])

    function handleClick() {
        navigate('/gerenciar/novoModelo');
    }

    return (
        <React.Fragment>
            <h2 style={{textAlign:'center' }}>Modelos</h2>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome</TableCell>
                            <TableCell>Descrição </TableCell>
                            <TableCell align="right">Data Criação</TableCell>
                            <TableCell>Edição</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {lista && lista.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">{row.nome}</TableCell>
                                <TableCell component="th" scope="row">{row.descricao}</TableCell>                                
                                <TableCell align="right">{DateFormat.dateAndTimeFormat(row.dtCriacao)}</TableCell>                                
                                <TableCell align="right">
                                    <IconButton aria-label="edit" onClick={(() => navigate('/gerenciar/editModelo/' + row.id))} >
                                        <EditIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className='to-right-div'>

                <Button variant="outlined" onClick={handleClick}>
                    Novo Modelo
                </Button>
            </div>

        </React.Fragment>

    );
}